import { getFinalCommonColumns, initialCommonColumns } from "./index";
import { colSettings } from "../../../common/components/table/agGrid/colSettings";
import { marketDynamicsColumns as mdCols } from "../marketDynamicsColumns";

export const getSoldColumns = shouldShowAdditionalInfoCols =>  [
    ...initialCommonColumns,
    { col: mdCols.listPrice, colDef: colSettings.numberMdVolume },
    { col: mdCols.soldPrice, colDef: colSettings.numberMdVolume },
    { col: mdCols.soldDate, colDef: colSettings.dateSm },
    ...getFinalCommonColumns(shouldShowAdditionalInfoCols),
];
